import React, { useState } from "react";
import Carousel from "./Carousel";
import PriceSection from "./PriceSection";
import VillaInfo from "./VillaInfo";

const VillaCard = ({ villa, listVilla, priority }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = villa?.image?.split(",") || [];
  const hasMultipleImages = images.length > 1;

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? villa.image.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === villa.image.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div
      className={`${
        listVilla
          ? "flex flex-1 bg-white  xlg:flex-row gap-2 flex-col border border-[#E0E4ED] p-4 rounded-lg transition-all ease-in-out duration-300 hover:bg-[#E0E4ED] group overflow-hidden"
          : ""
      } `}
    >
      <div
        className={`${
          listVilla
            ? "flex sm:items-center items-start sm:flex-row flex-col flex-1 sm:gap-6 gap-3"
            : "flex-col flex p-3 drop-shadow-custom bg-white border-b border-[#EDF2F7] rounded-t-2xl"
        }`}
      >
        <Carousel
          hasMultipleImages={hasMultipleImages}
          images={images}
          villa={villa}
          currentIndex={currentIndex}
          handlePrev={handlePrev}
          handleNext={handleNext}
          listVilla={listVilla}
          priority={priority}
        />
        <VillaInfo villa={villa} listVilla={listVilla} />
      </div>
      <PriceSection villa={villa} listVilla={listVilla} />
    </div>
  );
};

export default VillaCard;
